export default __webpack_public_path__ + "static/media/universityTuition.19126b79.svg";